/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Fragment } from 'react';
import Layout from '../../components/Layout';
import LayoutMobile from '../../components/LayoutMobile';
import DesktopHeader from '../../components/Header/desktop';
import GlobalHeader from '@components/Header';
import HomeDesktop from './desktop/home';
import MobileHome from './mobile/home';
import PopUpQRCode from './popupQRCode/popupContainer';
import metadata from '@global/assets/metadata.json';

async function action({ isMobile }) {
  return {
    chunks: ['home'],
    title: `${metadata['/'].title}`,
    description: `${metadata['/'].description}`,
    component: isMobile ? (
      <>
        <PopUpQRCode />
        <LayoutMobile>
          <GlobalHeader page="home" />
          <MobileHome />
        </LayoutMobile>
      </>
    ) : (
      <>
        <PopUpQRCode />
        <DesktopHeader page="home" />
        <Layout>
          <HomeDesktop />
        </Layout>
      </>
    )
  };
}

export default action;
